import React from 'react';
import { Box, Typography } from '@mui/material';
import { AnnouncementOutlined } from '@mui/icons-material';

import { DashboardMetricCardWrapper } from 'components/dashboard-metric-card';
import { useTotalFeedbackReceived } from 'store/apis';
import { TotalCard } from './total-card';

interface ChartTotalFeedbackReceivedProps {
  buildingId: number;
  start: string;
  end: string;
}

export const ChartTotalFeedbackReceived = ({ buildingId, start, end }: ChartTotalFeedbackReceivedProps) => {
  const { total = 0, isFetching } = useTotalFeedbackReceived({ buildingId, start, end });

  return (
    <DashboardMetricCardWrapper title="Total Feedback Received" loading={isFetching} loadingText="Loading feedback...">
      {total === 0 && (
        <Box sx={{ textAlign: 'center' }}>
          <AnnouncementOutlined color="primary" sx={{ fontSize: 40 }} />

          <Typography color="primary" sx={{ marginTop: 2 }}>
            No Feedback info
          </Typography>
        </Box>
      )}

      {total > 0 && <TotalCard value={total} valueUnit="FEEDBACK SUBMISSIONS" />}
    </DashboardMetricCardWrapper>
  );
};
